import 'core-js/fn/promise'

import React from 'react'
import { find } from 'lodash'
import { Button, ButtonToolbar } from 'react-bootstrap'

import * as scoreService from '../../services/score-service'
import * as scanService from '../../services/scan-service'
import * as unitService from '../../services/organizational-units-service'
import * as locationService from '../../services/location-service'

import Topbar from '../Topbar'
import ScanInfo from '../../components/ScanInfo'
import ResultsPdfModal from "./modal/ResultsPdfModal"

export default class Results extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.getUnitsForLocation = this.getUnitsForLocation.bind(this)

    this.state = {
      units: [],
      locations: [],
      wheelTotals: [],
      phaseTotals: [],
      matrix: []
    }
  }

  getScoresForRecentScan() {
    scanService.getMostRecentCompletedScan(this.state.unit.id).then(scan => {
      this.setState({ scan }, () => this.retrieveScores(scan.id))
    }).catch(this.setState({scan: undefined}))
  }

  retrieveScores(id) {
    Promise.all([
      scoreService.getScoreMatrix(id),
      scoreService.getPhaseTotals(id),
      scoreService.getSteeringWheelTotals(id)
    ]).then(([ matrix, phaseTotals, wheelTotals ]) => {
      this.setState({ matrix, phaseTotals, wheelTotals })
      window.sessionStorage.setItem('scores', JSON.stringify(this.state))
    })
  }

  clearScores() {
    this.setState({scan: undefined, matrix: [], phaseTotals: [], wheelTotals: []})
  }

  componentDidMount() {
    locationService.getLocations().then((locations) => {
      this.setState({ locations }, () => {
        const { scanId } = this.props.match.params

        if (scanId) {
          scanService.getScanById(scanId).then((scan) => {
            const location = find(locations, (loc) => loc.name === scan.locationName)
            unitService.getUnitsByLocation(location.id).then((units) => {
              const unit = find(units, (u) => u.id === scan.organizationalUnitId)
              this.setState({ scan, unit, units, location }, () => this.retrieveScores(scan.id))
            })
          })
        } else {
          const savedLocation = localStorage.getItem('selectedLocation')
          const savedUnit = localStorage.getItem('selectedUnit')

          if (savedLocation) {
            const location = JSON.parse(savedLocation);
            this.setState({ location }, () => {
              unitService.getUnitsByLocation(location.id).then((units) => {
                this.setState({ units }, () => {
                  if (savedUnit) {
                    const unit = JSON.parse(savedUnit);
                    const matchedUnit = find(units, (u) => u.id === unit.id);
                    if (matchedUnit) {
                      this.setState({ unit: matchedUnit }, () => this.getScoresForRecentScan(matchedUnit))
                    }
                  }
                })
              }).catch(err => {
                console.error("Error fetching units for location:", err)
              })
            })
          }
        }
      })
    })
  }

  componentWillReceiveProps(props) {
    this.clearScores()
    this.setState( {
      unit: undefined,
      location: undefined
    })
  }

  getUnitsForLocation() {
    this.clearScores()
    if (this.state.location) {
      unitService.getUnitsByLocation(this.state.location.id)
      .then(units => this.setState({ units: units, unit: undefined }))
      .catch(() => this.setState({ units: [], unit: undefined }))
    }
  }

  handleLocationChange(e) {
    this.setState({ location: e }, () => {
      localStorage.setItem('selectedLocation', JSON.stringify(e));
      this.getUnitsForLocation();
    });
  }

  handleUnitChange(e) {
    this.setState({ unit: e }, () => {
      localStorage.setItem('selectedUnit', JSON.stringify(e));
      this.getScoresForRecentScan();
    })
  }

  render() {
    const { units, locations, scan, matrix, phaseTotals, wheelTotals, unit, location } = this.state
    const currentUnit = this.state.unit

    return (
      <div className="content col-2 results">
        <div className="content-inner">
          <Topbar
            title="Resultaten"
            select={true}
            location={location}
            locations={locations}
            unit={unit}
            units={units}
            disabled={false}
            unitChange={this.handleUnitChange}
            locationChange={this.handleLocationChange}
          />

          <div className="inner">
            {scan && (scan.completedDate && (<ScanInfo scan={scan} matrix={matrix} phaseTotals={phaseTotals} wheelTotals={wheelTotals} originalScan={scan} currentUnit={currentUnit} /> ))}
            {(!scan || !scan.completedDate) && unit && <h2>Geen afgeronde scans beschikbaar</h2>}
          </div>

          {scan && (
            <div id="action-buttons">
              <ButtonToolbar>
                <ResultsPdfModal
                  text="<p>U kunt de resultaten van deze scan bewaren of bijvoorbeeld delen met uw bestuur of en locatieverantwoordelijke. Klikken op Rapportage toont de resultaten in een nieuwe webpagina buiten BrandWijzer, inclusief de beantwoorde vragen. Deze pagina kunt u eenvoudig printen, opslaan of de link bewaren of delen.</p>"
                  title="Rapportage downloaden"
                  textbtn="Rapportage (PDF)"
                />
                {scan && <Button className="view-entry action-btn" onClick={() => this.props.history.push(`/analysis/${this.state.scan.id}`)}>Analyse</Button>}
              </ButtonToolbar>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Results/index.js